/* =========================================================
   LaonaBot · 라오나봇 — 사이트 정보
   라오나봇은 아이닷메타(I.META)의 시제품 서비스봇이다 (2026-10 개편).
   회원이 원하는 기능을 모듈로 조합해 시제품을 스스로 만들도록 돕는다 —
   수동(연결도 직접 그리기, 무료) 또는 라오나봇과 대화로 설계(무료로 시작, 사용량이 무료 한도를 넘으면 이용료 1만 원).
   ========================================================= */
export const LAONA = {
  name: "LaonaBot",
  nameKo: "라오나봇",
  base: "/laonabot",
  tagline: "대화로 설계하는 나만의 시제품",
  operator: "아이닷메타(I.META)",
};

/* 라오나 키트 — 나만의 전자 장치를 스스로 만들어 보는 서비스의 이름 (2026-11, '시제품 직접 만들기'에서 개편).
   라오나봇(유료 대화 설계 봇)과 구분한다. I.META 헤더의 진입 버튼과 /laonabot 헤더의 타이틀에 쓴다.
   desc — I.META 헤더 버튼에 마우스를 올리면 나오는 설명 */
export const SELFPROTO = {
  name: "라오나 키트",
  lines: ["라오나", "키트"], // 좁은 화면에서 두 줄로 쌓는 단위
  en: "LaonaKit",
  desc: "나만의 전자 장치를 스스로 만들어 보세요. 원하는 기능을 고르고 검증된 모듈을 조합하면, 핀맵에 맞춘 펌웨어까지 만들어 드립니다.",
};

export const LAONA_NAV = [
  /* short — 휴대폰 상단 메뉴에서 쓰는 짧은 이름. 소개는 휴대폰에서 숨긴다(로고가 소개로 간다) */
  { to: "/laonabot", label: "소개", end: true, mobileHide: true },
  { to: "/laonabot/recipes", label: "레시피" },
  { to: "/laonabot/projects", label: "내 프로젝트", short: "프로젝트" },
  { to: "/laonabot/library", label: "자료실" },
];

/* 라오나봇 프로젝트 — 백엔드 app/laona_projects.py 의 status 와 맞춘다 */
export const PROJECT_STATUS = {
  DEPOSIT_PENDING: { label: "선금 확인 대기", tone: "wait" }, // 예전 규칙(시작할 때 선금)의 상태
  MANUAL: { label: "직접 만들기로 넘김", tone: "done" },
  ACTIVE: { label: "설계 중", tone: "on" },
  DESIGNED: { label: "설계 정리됨", tone: "done" },
  APPROVED: { label: "저장됨 · 주문 전", tone: "done" },  // [내 프로젝트로 저장] — 내 프로젝트에서 주문한다
  BUILT: { label: "펌웨어 완성", tone: "done" },          // 예전 자동 빌드로 완성된 프로젝트
  ORDERED: { label: "주문 · 입금 대기", tone: "wait" },
  PAID: { label: "입금 확인 · 개발 중", tone: "on" },
  SHIPPED: { label: "발송됨", tone: "done" },
  DELIVERED: { label: "배송 완료", tone: "done" },
};
/* 라오나봇 이용 규칙 — 백엔드 LAONA_DEPOSIT · LAONA_FREE_KRW 와 맞춘다.
   무료로 시작하고, API 사용 비용이 FREE_KRW 를 넘으면 이용료 DEPOSIT 을 내고 이어서 대화 · 설계하거나 직접 만들기로 넘어간다.
   펌웨어 개발 · 빌드(기본 FW_FEE)는 내 프로젝트에서 주문할 때 부품과 함께 낸다 */
export const FW_FEE = 50000;
export const DEPOSIT = 10000;
export const FREE_KRW = 1000;

/* 자료실 분류 — 백엔드 app/forum.py 의 LAONA_CATEGORIES 와 글자 그대로 맞춘다.
   글은 라오나봇 관리자가 자료실 화면의 '자료 올리기'(또는 SSTOA '포럼 관리')에서 이 분류를 골라 쓴다. */
export const LAONA_CATEGORIES = [
  { id: "laona-robot", label: "로봇", desc: "완성 로봇 소개 · 조립 가이드" },
  { id: "laona-module", label: "모듈", desc: "모듈 핀맵 · PinWire 모듈 파일" },
  { id: "laona-case", label: "3D 케이스", desc: "STL · 출력 설정" },
  { id: "laona-code", label: "펌웨어", desc: "ESP32 예제 · 라이브러리" },
];

/* 브라우저 탭 아이콘 — 라오나봇 화면에 있는 동안만 바꿔 두고 나갈 때 되돌린다 */
export const LAONA_ICONS = [
  { rel: "icon", type: "image/svg+xml", href: "/laonabot/icon.svg" },
  { rel: "icon", type: "image/png", sizes: "192x192", href: "/laonabot/icon-192.png" },
  { rel: "apple-touch-icon", href: "/laonabot/icon-192.png" },
];
export const IMETA_ICONS = [
  { rel: "icon", href: "/favicon.ico", sizes: "any" },
  { rel: "icon", type: "image/png", sizes: "48x48", href: "/icon-48.png" },
  { rel: "icon", type: "image/png", sizes: "96x96", href: "/icon-96.png" },
  { rel: "icon", type: "image/png", sizes: "144x144", href: "/icon-144.png" },
  { rel: "apple-touch-icon", href: "/logo192.png" },
];
